import { getRecommendationData } from "../context/recommendationContext";
import { Logger } from "../utils/logger";
import { isPreviewMode } from "../utils/previewUtils";

export const PagebuilderTextPlaceholder = {
  promoterName: "[promoterName]",
  recommendationName: "[recommendationName]",
};

const PlaceholderFallbacks: Record<string, string> = {
  promoterName: "unser Team",
  recommendationName: "ein Kontakt aus deinem Netzwerk",
};

/**
 * Ersetzt Platzhalter unter Berücksichtigung des Preview-Modus.
 */
export function replacePlaceholdersFromContext(text: string): string {
  const data = getRecommendationData();

  if (isPreviewMode()) {
    Logger.info("👁️ Preview-Modus aktiv – Platzhalter bleiben sichtbar.");
    return text;
  }

  if (!data || Object.keys(data).length === 0) {
    Logger.warn("⚠️ recommendationContext leer – es werden nur Fallbacks verwendet.");
  } else {
    Logger.debug("📦 recommendationContext:", data);
  }

  return replacePlaceholders(text, data ?? {});
}

/**
 * Ersetzt Platzhalter synchron anhand eines übergebenen Datensatzes.
 */
export function replacePlaceholders(text: string, data: Record<string, any>): string {
  if (!text || typeof text !== "string") return "";

  const placeholderPattern = /\[([a-zA-Z0-9]+)\]/g;

  return text.replace(placeholderPattern, (_match, key: string) => {
    if (!(key in PagebuilderTextPlaceholder)) {
      Logger.debug(`⛔ Unbekannter Platzhalter: [${key}]`);
      return "";
    }

    let replacement = "";

    if (key === "recommendationName") {
      const name = data?.name;
      if (name && typeof name === "string") replacement = name;
    } else if (key === "promoterName") {
      const promoter = data?.promoterName;
      if (promoter && typeof promoter === "string") replacement = promoter;
    }

    // Fallback
    if (!replacement) {
      replacement = PlaceholderFallbacks[key] ?? "";
    }

    return replacement;
  });
}
